<template>
  <el-container id="referencia_bancaria" style="justify-content: center">
    <el-col
      class="main-wrapper"
      :xs="22"
      :sm="21"
      :md="14"
      :lg="12"
      :xl="12"
    >
      <el-row>
        <el-button
          type="primary"
          tag="button"
          @click="$goBack()"
          style="width:100%"
        >
          VOLVER
        </el-button>
      </el-row>
      <br>
      <el-row
        type="flex"
        justify="center"
      >
        <h2>REFERENCIA BANCARIA</h2>
      </el-row>
      <el-row class="summary">
        <el-col>
          <dt>
            Referencia:
          </dt>
          <dd>{{ reference }}</dd>

          <dt>
            Cuenta predial:
          </dt>
          <dd>{{ user.cuentadepredial }}</dd>

          <dt>
            Total A Pagar:
          </dt>
          <dd>
            {{ $currencyFormater(cart.total) }}
          </dd>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <router-link
          tag="button"
          to="/estado-de-cuenta"
          class="el-button el-button--primary"
          style="width:100%"
        >
          IMPRIMIR RECIBO
        </router-link>
      </el-row>
      <br>
      <el-row>
        <el-col>
          <router-link
            tag="button"
            to="/busqueda-del-predio"
            class="el-button el-button--primary"
            style="width:100%"
          >
            <span>
              CONSULTAR OTRA CUENTA
            </span>
          </router-link>
        </el-col>
      </el-row>
    </el-col>
  </el-container>
</template>

<script>
import qrcode from 'qrcode-generator';
import Moment from 'moment';
import { mapState } from 'vuex';

import generate from '../../utils/generateRef';

export default {
  data() {
    return {
      reference: '',
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
      user: (state) => state.predio.user,
    }),
  },
  methods: {
    generateRef() {
      const date = new Moment().format('DD/MM/YYYY');
      const ref = this.user.cuentadepredial;
      const { LINEA_BANCOS } = generate(date, this.cart.total, ref);
      return LINEA_BANCOS;
    },
    async generateQR() {
      const qr = qrcode(0, 'L');
      qr.addData(this.reference);
      qr.make();
      const image = await qr.createSvgTag(10);
      const container = document.getElementById('qr');
      if (container) {
        container.innerHTML = image;
      }
    },
  },
  created() {
    this.reference = this.generateRef();
    this.generateQR();
  },
};
</script>

<style lang="scss" scoped>
#referencia_bancaria {
  .el-button {
    background-color: #884E93;
    &:hover {
      opacity: 0.9;
    }
  }
  .main-wrapper {
    h2 {
      text-align: center;
    }
    .summary {
      background-color: #DCDFE7;
      border-radius: 10px;
      padding: 10px;
      margin-top:10px;
      dt {
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
        margin-top: 10px;
        &:first-child {
          margin-top: 0px !important;
        }
      }
      dd {
        color: #606266;
      }
    }
  }
}
</style>
